export const seoKeywords = {
  name: 'keywords',
  content:
    'Stellar development, Soroban development, hire Stellar developer, Stellar blockchain development company, Soroban smart contract development, blockchain development, Stellar network development, enterprise Stellar development, DeFi on Stellar, Stellar Community Fund, payments on Stellar',
};

export const stellarProductDevelopmentSeo = {
  title: 'Stellar Product Development Services with Rumble Fish',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Stellar and Soroban product development with Rumble Fish. We build fast, low-cost, compliant blockchain systems: cross-border payments, tokenization platforms, Soroban smart contracts, and DeFi applications. Two-time Stellar Community Fund grantee, building full-stack Stellar software that ships.',
    },
  ],
};
